// Translations for the cookie banner and legal pages (Privacy Policy, Terms).
// Kept separate from translations.js to keep that file maintainable.

export const LEGAL_COPY = {
  pt: {
    cookieBanner: {
      title: "🍪 Privacidade e Cookies",
      body: "Este site usa armazenamento técnico estritamente necessário (preferência de língua e sessão do chat) para funcionar corretamente. Não usamos cookies de publicidade nem partilhamos os seus dados com terceiros.",
      accept: "Aceitar",
      learnMore: "Saber mais",
    },
    footer: {
      privacy: "Política de Privacidade",
      terms: "Termos & Condições",
      cookies: "Política de Cookies",
    },
    privacy: {
      pageTitle: "Política de Privacidade · TVCabSat, Lda",
      title: "Política de Privacidade",
      overline: "Compromisso TVCabSat",
      lastUpdate: "Última atualização: 4 de Maio de 2026",
      intro:
        "Na TVCABSAT, Lda valorizamos a sua privacidade e estamos comprometidos em proteger os seus dados pessoais. Esta política descreve como recolhemos, utilizamos e protegemos a informação que partilha connosco.",
      sections: [
        {
          h: "1. Responsável pelo tratamento",
          p: "TVCABSAT, Lda · Rua Padre Manuel Ruela Pombo, 40, R/C e 3.º andar, Maianga · Luanda · Angola. Contacto: comercial@tvcabsat.ao",
        },
        {
          h: "2. Dados que recolhemos",
          p: "Apenas recolhemos dados que o utilizador nos fornece voluntariamente através dos formulários (nome, e-mail, telefone, mensagem) e, no caso de candidaturas a emprego, os documentos anexados (CV e fotografia). Não recolhemos dados de navegação para fins publicitários.",
        },
        {
          h: "3. Finalidade do tratamento",
          p: "Os dados são utilizados exclusivamente para responder a pedidos comerciais, suporte técnico, candidaturas a vagas, e melhorar a qualidade dos nossos serviços.",
        },
        {
          h: "4. Armazenamento técnico (cookies)",
          p: "Este site utiliza apenas armazenamento local técnico estritamente necessário: (a) preferência de idioma — guardada localmente no seu navegador; (b) identificador temporário da sessão de chat — apagado ao fechar o separador. Não utilizamos cookies de publicidade, tracking de terceiros ou perfis comportamentais.",
        },
        {
          h: "5. Partilha com terceiros",
          p: "Não vendemos nem cedemos os seus dados. As mensagens enviadas através do formulário de contacto são encaminhadas via Resend (provedor de email transacional) e as conversas do assistente virtual são processadas por modelos de IA da Anthropic, exclusivamente para gerar a resposta apresentada.",
        },
        {
          h: "6. Conservação",
          p: "Os pedidos de contacto e candidaturas são conservados durante o tempo necessário para o seu tratamento e até 5 anos para efeitos legais e fiscais aplicáveis em Angola.",
        },
        {
          h: "7. Os seus direitos",
          p: "Pode solicitar a qualquer momento o acesso, retificação ou eliminação dos seus dados pessoais, bem como retirar o consentimento previamente prestado. Para exercer estes direitos contacte-nos em comercial@tvcabsat.ao.",
        },
        {
          h: "8. Segurança",
          p: "Adotamos medidas técnicas e organizativas adequadas (encriptação em trânsito via HTTPS, acesso restrito, e armazenamento em infraestrutura segura) para proteger os seus dados contra acesso ou divulgação não autorizados.",
        },
        {
          h: "9. Alterações",
          p: "Esta política pode ser atualizada periodicamente. A versão em vigor encontra-se sempre disponível nesta página.",
        },
        {
          h: "10. Legislação aplicável",
          p: "Esta política rege-se pela Lei n.º 22/11, de 17 de Junho — Lei da Proteção de Dados Pessoais da República de Angola.",
        },
      ],
    },
    terms: {
      pageTitle: "Termos & Condições · TVCabSat, Lda",
      title: "Termos & Condições de Utilização",
      overline: "Utilização do Site",
      lastUpdate: "Última atualização: 4 de Maio de 2026",
      intro:
        "Ao aceder e utilizar o site tvcabsat.ao, o utilizador aceita os termos e condições aqui descritos. Caso não concorde, deverá abster-se de utilizar este sítio.",
      sections: [
        {
          h: "1. Propriedade intelectual",
          p: "Todos os conteúdos do site — textos, imagens, logótipos, identidade visual, código e estrutura — são propriedade da TVCABSAT, Lda ou dos respetivos titulares, e estão protegidos pela legislação angolana e internacional. É proibida a reprodução total ou parcial sem autorização prévia por escrito.",
        },
        {
          h: "2. Marcas registadas",
          p: "Marcas de terceiros referenciadas no site (Cisco, Motorola, Hytera, Alcatel, Intelbras, DStv, entre outras) pertencem aos respetivos titulares e são apresentadas exclusivamente para fins informativos no âmbito da nossa atividade de revenda e instalação autorizada.",
        },
        {
          h: "3. Utilização do site",
          p: "O utilizador compromete-se a usar o site para fins legítimos, abstendo-se de comprometer a sua segurança, integridade ou funcionamento. É proibido o uso de bots, scraping massivo ou qualquer atividade que prejudique o serviço.",
        },
        {
          h: "4. Conteúdo informativo",
          p: "A informação aqui apresentada é meramente informativa e não constitui proposta contratual. Especificações técnicas, preços e disponibilidade podem variar — confirme sempre connosco antes de tomar qualquer decisão.",
        },
        {
          h: "5. Limitação de responsabilidade",
          p: "A TVCABSAT, Lda não se responsabiliza por interrupções temporárias do serviço, erros tipográficos, nem por danos resultantes do uso indevido das informações aqui disponibilizadas.",
        },
        {
          h: "6. Ligações externas",
          p: "Este site pode conter ligações para sites de terceiros. A TVCABSAT, Lda não controla nem é responsável pelo conteúdo desses sites.",
        },
        {
          h: "7. Foro e lei aplicável",
          p: "Quaisquer conflitos relacionados com a utilização deste site serão regulados pela legislação angolana e submetidos à jurisdição dos tribunais competentes da Comarca de Luanda.",
        },
      ],
    },
    back: "← Voltar à página inicial",
  },

  en: {
    cookieBanner: {
      title: "🍪 Privacy & Cookies",
      body: "This site uses strictly-necessary technical storage (language preference and chat session) to function correctly. We do not use advertising cookies nor share your data with third parties.",
      accept: "Accept",
      learnMore: "Learn more",
    },
    footer: {
      privacy: "Privacy Policy",
      terms: "Terms & Conditions",
      cookies: "Cookie Policy",
    },
    privacy: {
      pageTitle: "Privacy Policy · TVCabSat, Lda",
      title: "Privacy Policy",
      overline: "TVCabSat Commitment",
      lastUpdate: "Last updated: 4 May 2026",
      intro:
        "At TVCABSAT, Lda we value your privacy and are committed to protecting your personal data. This policy describes how we collect, use and safeguard the information you share with us.",
      sections: [
        {
          h: "1. Data controller",
          p: "TVCABSAT, Lda · Rua Padre Manuel Ruela Pombo, 40, R/C and 3rd floor, Maianga · Luanda · Angola. Contact: comercial@tvcabsat.ao",
        },
        {
          h: "2. Data we collect",
          p: "We only collect data you voluntarily provide through our forms (name, e-mail, phone, message) and, for job applications, the attached documents (CV and photograph). We do not collect browsing data for advertising purposes.",
        },
        {
          h: "3. Purpose of processing",
          p: "Data is used exclusively to reply to commercial enquiries, deliver technical support, process job applications, and improve the quality of our services.",
        },
        {
          h: "4. Technical storage (cookies)",
          p: "This site only uses strictly-necessary technical local storage: (a) language preference — saved locally in your browser; (b) temporary chat session identifier — deleted on tab close. We do not use advertising cookies, third-party tracking or behavioural profiles.",
        },
        {
          h: "5. Sharing with third parties",
          p: "We do not sell or transfer your data. Messages sent through the contact form are routed via Resend (transactional email provider) and chatbot conversations are processed by Anthropic AI models, exclusively to generate the displayed reply.",
        },
        {
          h: "6. Retention",
          p: "Contact requests and applications are kept for the time required to handle them and for up to 5 years for applicable legal and tax purposes in Angola.",
        },
        {
          h: "7. Your rights",
          p: "You may request at any time to access, rectify or delete your personal data, and to withdraw any previously given consent. To exercise these rights please contact comercial@tvcabsat.ao.",
        },
        {
          h: "8. Security",
          p: "We adopt appropriate technical and organisational measures (HTTPS in transit, restricted access, secure infrastructure) to protect your data against unauthorised access or disclosure.",
        },
        {
          h: "9. Changes",
          p: "This policy may be updated periodically. The current version is always available on this page.",
        },
        {
          h: "10. Applicable law",
          p: "This policy is governed by Law no. 22/11 of 17 June — the Angolan Personal Data Protection Act.",
        },
      ],
    },
    terms: {
      pageTitle: "Terms & Conditions · TVCabSat, Lda",
      title: "Terms & Conditions of Use",
      overline: "Website Use",
      lastUpdate: "Last updated: 4 May 2026",
      intro:
        "By accessing and using tvcabsat.ao, you accept the terms and conditions set out below. If you do not agree, please refrain from using this site.",
      sections: [
        {
          h: "1. Intellectual property",
          p: "All content on this site — texts, images, logos, visual identity, code and structure — is the property of TVCABSAT, Lda or its respective owners, and is protected by Angolan and international law. Total or partial reproduction is forbidden without prior written authorisation.",
        },
        {
          h: "2. Trademarks",
          p: "Third-party brands referenced on this site (Cisco, Motorola, Hytera, Alcatel, Intelbras, DStv, among others) belong to their respective owners and are shown for informational purposes only, in the scope of our authorised resale and installation activity.",
        },
        {
          h: "3. Site use",
          p: "You agree to use the site for lawful purposes only, refraining from compromising its security, integrity or operation. The use of bots, mass scraping or any activity harmful to the service is forbidden.",
        },
        {
          h: "4. Informational content",
          p: "The information provided here is strictly informational and does not constitute a contractual offer. Technical specifications, prices and availability may vary — always confirm with us before taking any decision.",
        },
        {
          h: "5. Limitation of liability",
          p: "TVCABSAT, Lda accepts no liability for temporary service interruptions, typographical errors, or damages arising from improper use of the information made available here.",
        },
        {
          h: "6. External links",
          p: "This site may contain links to third-party sites. TVCABSAT, Lda does not control and is not responsible for the content of those sites.",
        },
        {
          h: "7. Jurisdiction and applicable law",
          p: "Any disputes arising from the use of this site are governed by Angolan law and submitted to the jurisdiction of the competent courts of Luanda.",
        },
      ],
    },
    back: "← Back to home",
  },

  es: {
    cookieBanner: {
      title: "🍪 Privacidad y Cookies",
      body: "Este sitio utiliza almacenamiento técnico estrictamente necesario (preferencia de idioma y sesión del chat) para funcionar correctamente. No usamos cookies publicitarias ni compartimos sus datos con terceros.",
      accept: "Aceptar",
      learnMore: "Saber más",
    },
    footer: {
      privacy: "Política de Privacidad",
      terms: "Términos y Condiciones",
      cookies: "Política de Cookies",
    },
    privacy: {
      pageTitle: "Política de Privacidad · TVCabSat, Lda",
      title: "Política de Privacidad",
      overline: "Compromiso TVCabSat",
      lastUpdate: "Última actualización: 4 de mayo de 2026",
      intro:
        "En TVCABSAT, Lda valoramos su privacidad y estamos comprometidos con la protección de sus datos personales. Esta política describe cómo recopilamos, usamos y protegemos la información que comparte con nosotros.",
      sections: [
        {
          h: "1. Responsable del tratamiento",
          p: "TVCABSAT, Lda · Rua Padre Manuel Ruela Pombo, 40, planta baja y 3.º piso, Maianga · Luanda · Angola. Contacto: comercial@tvcabsat.ao",
        },
        {
          h: "2. Datos que recopilamos",
          p: "Solo recopilamos datos que el usuario nos proporciona voluntariamente a través de los formularios (nombre, correo, teléfono, mensaje) y, en candidaturas de empleo, los documentos adjuntos (CV y fotografía). No recopilamos datos de navegación con fines publicitarios.",
        },
        {
          h: "3. Finalidad del tratamiento",
          p: "Los datos se utilizan exclusivamente para responder consultas comerciales, brindar soporte técnico, gestionar candidaturas y mejorar la calidad de nuestros servicios.",
        },
        {
          h: "4. Almacenamiento técnico (cookies)",
          p: "Este sitio solo utiliza almacenamiento local técnico estrictamente necesario: (a) preferencia de idioma — guardada localmente en su navegador; (b) identificador temporal de la sesión de chat — eliminado al cerrar la pestaña. No usamos cookies publicitarias, seguimiento de terceros ni perfiles conductuales.",
        },
        {
          h: "5. Compartición con terceros",
          p: "No vendemos ni cedemos sus datos. Los mensajes enviados por el formulario se enrutan vía Resend (proveedor de email transaccional) y las conversaciones del asistente virtual se procesan con modelos de IA de Anthropic, exclusivamente para generar la respuesta mostrada.",
        },
        {
          h: "6. Conservación",
          p: "Las solicitudes de contacto y candidaturas se conservan durante el tiempo necesario para su tratamiento y hasta 5 años por motivos legales y fiscales aplicables en Angola.",
        },
        {
          h: "7. Sus derechos",
          p: "Puede solicitar en cualquier momento el acceso, rectificación o eliminación de sus datos personales, así como retirar el consentimiento previamente otorgado. Para ejercer estos derechos contáctenos en comercial@tvcabsat.ao.",
        },
        {
          h: "8. Seguridad",
          p: "Adoptamos medidas técnicas y organizativas adecuadas (cifrado HTTPS en tránsito, acceso restringido, infraestructura segura) para proteger sus datos frente a accesos o divulgaciones no autorizados.",
        },
        {
          h: "9. Cambios",
          p: "Esta política puede actualizarse periódicamente. La versión vigente siempre está disponible en esta página.",
        },
        {
          h: "10. Legislación aplicable",
          p: "Esta política se rige por la Ley n.º 22/11, de 17 de junio — Ley de Protección de Datos Personales de la República de Angola.",
        },
      ],
    },
    terms: {
      pageTitle: "Términos y Condiciones · TVCabSat, Lda",
      title: "Términos y Condiciones de Uso",
      overline: "Uso del Sitio",
      lastUpdate: "Última actualización: 4 de mayo de 2026",
      intro:
        "Al acceder y utilizar tvcabsat.ao, el usuario acepta los términos y condiciones aquí descritos. Si no está de acuerdo, deberá abstenerse de utilizar este sitio.",
      sections: [
        {
          h: "1. Propiedad intelectual",
          p: "Todo el contenido del sitio — textos, imágenes, logotipos, identidad visual, código y estructura — es propiedad de TVCABSAT, Lda o de sus titulares, y está protegido por la legislación angoleña e internacional. Queda prohibida la reproducción total o parcial sin autorización previa por escrito.",
        },
        {
          h: "2. Marcas registradas",
          p: "Las marcas de terceros referenciadas en el sitio (Cisco, Motorola, Hytera, Alcatel, Intelbras, DStv, entre otras) pertenecen a sus respectivos titulares y se presentan únicamente con fines informativos en el ámbito de nuestra actividad de reventa e instalación autorizada.",
        },
        {
          h: "3. Uso del sitio",
          p: "El usuario se compromete a usar el sitio con fines legítimos, sin comprometer su seguridad, integridad o funcionamiento. Se prohíbe el uso de bots, scraping masivo o cualquier actividad que perjudique el servicio.",
        },
        {
          h: "4. Contenido informativo",
          p: "La información aquí presentada es meramente informativa y no constituye oferta contractual. Las especificaciones técnicas, precios y disponibilidad pueden variar — confirme siempre con nosotros antes de tomar cualquier decisión.",
        },
        {
          h: "5. Limitación de responsabilidad",
          p: "TVCABSAT, Lda no se responsabiliza por interrupciones temporales del servicio, errores tipográficos, ni por daños derivados del uso indebido de la información aquí disponible.",
        },
        {
          h: "6. Enlaces externos",
          p: "Este sitio puede contener enlaces a sitios de terceros. TVCABSAT, Lda no controla ni se responsabiliza del contenido de esos sitios.",
        },
        {
          h: "7. Foro y ley aplicable",
          p: "Cualquier conflicto relacionado con el uso de este sitio se regirá por la legislación angoleña y se someterá a la jurisdicción de los tribunales competentes de Luanda.",
        },
      ],
    },
    back: "← Volver al inicio",
  },
};
